module.exports = __webpack_public_path__ + "img/icon-close-circle.89f28984.svg";